import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { CrmHeader } from './CrmHeader';
import { CrmSidebar } from './CrmSidebar';

interface CrmLayoutProps {
  showSidebar?: boolean;
}

export function CrmLayout({ showSidebar = true }: CrmLayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col font-sans selection:bg-indigo-600 selection:text-white">
      <CrmHeader 
        onToggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      
      <div className="flex-1 flex overflow-hidden">
        {showSidebar && (
          <CrmSidebar isCollapsed={isSidebarCollapsed} />
        )}
        
        <main className="flex-1 overflow-y-auto bg-slate-950 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
